import { render, staticRenderFns } from "./HealthSafetyEducationNotPerformedChart.vue?vue&type=template&id=3a6476c4&scoped=true&"
import script from "./HealthSafetyEducationNotPerformedChart.vue?vue&type=script&lang=ts&"
export * from "./HealthSafetyEducationNotPerformedChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6476c4",
  null
  
)

export default component.exports